import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c89a1df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "modais" }
const _hoisted_2 = {
  class: "modal fade modal-md",
  id: "ModalUsersIpiranga",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalCenterTitle",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_4 = {
  class: "modal-content",
  style: {"border-radius":"10px"}
}
const _hoisted_5 = { class: "modal-header p-5" }
const _hoisted_6 = { class: "d-flex gap-4 p-0 align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div style=\"background:rgb(236, 236, 236);\" class=\"p-3 rounded\" data-v-2c89a1df><svg width=\"22\" height=\"22\" viewBox=\"0 0 25 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-2c89a1df><g clip-path=\"url(#clip0_4339_1347)\" data-v-2c89a1df><path opacity=\"0.4\" d=\"M24.3113 6.93848L22.0604 9.18945C21.8309 9.41895 21.4598 9.41895 21.2303 9.18945L15.8104 3.76953C15.5809 3.54004 15.5809 3.16895 15.8104 2.93945L18.0613 0.688477C18.9744 -0.224609 20.4588 -0.224609 21.3768 0.688477L24.3113 3.62305C25.2293 4.53613 25.2293 6.02051 24.3113 6.93848ZM13.8768 4.87305L1.05451 17.6953L0.0193508 23.6279C-0.122251 24.4287 0.575992 25.1221 1.37677 24.9854L7.30939 23.9453L20.1317 11.123C20.3611 10.8936 20.3611 10.5225 20.1317 10.293L14.7117 4.87305C14.4774 4.64355 14.1063 4.64355 13.8768 4.87305ZM6.05939 16.5967C5.79084 16.3281 5.79084 15.8984 6.05939 15.6299L13.5789 8.11035C13.8475 7.8418 14.2772 7.8418 14.5457 8.11035C14.8143 8.37891 14.8143 8.80859 14.5457 9.07715L7.02619 16.5967C6.75763 16.8652 6.32794 16.8652 6.05939 16.5967ZM4.29669 20.7031H6.64044V22.4756L3.49103 23.0273L1.97248 21.5088L2.52423 18.3594H4.29669V20.7031Z\" fill=\"#203972\" data-v-2c89a1df></path><path d=\"M13.8768 4.87305L1.05451 17.6953L0.0193508 23.6279C-0.122251 24.4287 0.575991 25.1221 1.37677 24.9854L7.30939 23.9453L20.1317 11.123C20.3611 10.8936 20.3611 10.5225 20.1317 10.293L14.7117 4.87305C14.4774 4.64355 14.1063 4.64355 13.8768 4.87305ZM6.05939 16.5967C5.79083 16.3281 5.79083 15.8984 6.05939 15.6299L13.5789 8.11035C13.8475 7.8418 14.2772 7.8418 14.5457 8.11035C14.8143 8.37891 14.8143 8.80859 14.5457 9.07715L7.02619 16.5967C6.75763 16.8652 6.32794 16.8652 6.05939 16.5967ZM4.29669 20.7031H6.64044V22.4756L3.49103 23.0273L1.97248 21.5088L2.52423 18.3594H4.29669V20.7031Z\" fill=\"#203972\" data-v-2c89a1df></path></g><defs data-v-2c89a1df><clipPath id=\"clip0_4339_1347\" data-v-2c89a1df><rect width=\"25\" height=\"25\" fill=\"white\" data-v-2c89a1df></rect></clipPath></defs></svg></div>", 1)
const _hoisted_8 = {
  key: 0,
  class: "m-0 subtitulo cor_texto_1"
}
const _hoisted_9 = {
  key: 1,
  class: "m-0 subtitulo cor_texto_1"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  fill: "#afb7bd",
  widxmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z" })
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  class: "modal-body d-flex flex-column p-5 gap-5",
  style: {"background":"rgb(249, 249, 249) !important"},
  id: "modalBody"
}
const _hoisted_13 = { class: "d-flex flex-column gap-3 m-0 p-0 col-12" }
const _hoisted_14 = { class: "d-flex flex-column gap-1" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Nome", -1))
const _hoisted_16 = { class: "d-flex flex-column gap-1" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Email", -1))
const _hoisted_18 = { class: "d-flex flex-column gap-1" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Região", -1))
const _hoisted_20 = { class: "d-flex flex-column gap-1" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Cargo", -1))
const _hoisted_22 = { class: "modal-footer d-flex flex-nowrap justify-content-end align-items-center p-5" }
const _hoisted_23 = {
  key: 0,
  style: {"font-size":"medium","height":"18px","width":"18px"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  height: "1em",
  viewBox: "0 0 448 512"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z" }, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 0,
  style: {"font-size":"medium","height":"18px","width":"18px"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  key: 1,
  width: "20",
  height: "20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 416c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z" }, null, -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tem certeza de que deseja excluir este usuário?", -1))
const _hoisted_36 = { class: "dialog-footer d-flex justify-content-end gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Button = _resolveComponent("Button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", null, [
                (_ctx.usuario.id)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Editar dados do usuário"))
                  : (_openBlock(), _createElementBlock("p", _hoisted_9, "Adicionar novo usuário"))
              ])
            ]),
            _createElementVNode("div", {
              class: "cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal())),
              "aria-label": "Close"
            }, _hoisted_11)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("ul", _hoisted_13, [
              _createElementVNode("li", _hoisted_14, [
                _hoisted_15,
                _createVNode(_component_el_input, {
                  modelValue: _ctx.user.nome,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.nome) = $event)),
                  placeholder: "Digite..."
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("li", _hoisted_16, [
                _hoisted_17,
                _createVNode(_component_el_input, {
                  modelValue: _ctx.user.email,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.email) = $event)),
                  placeholder: "Digite..."
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("li", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_el_input, {
                  modelValue: _ctx.user.regiao,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.regiao) = $event)),
                  placeholder: "Digite..."
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("li", _hoisted_20, [
                _hoisted_21,
                _createVNode(_component_el_input, {
                  modelValue: _ctx.user.cargo,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.cargo) = $event)),
                  placeholder: "Digite..."
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            (_ctx.user.id)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  type: "button",
                  variant: "primary",
                  text: "Excluir",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.dialogVisible = true))
                }, {
                  default: _withCtx(() => [
                    (_ctx.loadExcluir)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_26, _hoisted_28))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_Button, {
              variant: "secondary",
              disabled: _ctx.loadSave,
              text: _ctx.user.id ? 'Editar' : 'Salvar',
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.salvaUsuario(_ctx.user.id && _ctx.user.id)))
            }, {
              default: _withCtx(() => [
                (_ctx.loadSave)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_32, _hoisted_34))
              ]),
              _: 1
            }, 8, ["disabled", "text"])
          ])
        ])
      ])
    ]),
    (_ctx.usuario.id)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: _ctx.dialogVisible,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dialogVisible) = $event)),
          title: "Confirme sua ação",
          width: "30%"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_36, [
              _createVNode(_component_Button, {
                type: "button",
                variant: "primary",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialogVisible = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cancelar")
                ]),
                _: 1
              }),
              _createVNode(_component_Button, {
                variant: "secondary",
                type: "button",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.deletarUsuario(_ctx.user.id))),
                disabled: _ctx.loadExcluir
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Confirmar")
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          default: _withCtx(() => [
            _hoisted_35
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}